export default __webpack_public_path__ + "images/c00dd48439df54dd029e568beda4fcb2-chile_flag.png";